<svelte:options runes={false} />

<script>
  import { minorToMoney } from '../../api/invoices';
  import { formatHours } from '../format.mjs';

  export let bit;
  export let currency;
  export let rates;
  export let canManage = false;
  export let editable = false;
  export let onToggleReported;
  export let onEdit;
  export let onRemove;

  // "Absent lines beat rows of zeroes" (UX north star, commitment 5). Every
  // operator work item used to carry `pending CA$0.00/h` and `paid CA$0.00/h`
  // whether or not anyone had paid, so the one item that had been paid for
  // looked exactly like the twenty that had not.
  $: pendingMinor = rates?.pendingMinor || 0;
  $: paidMinor = rates?.paidMinor || 0;
</script>

<article class="bit-card work-item" class:unreported={!bit.reported}>
  <div class="work-item-head">
    <h3>{bit.label}</h3>
    <span class="figure work-item-hours">{formatHours(bit.hours)}</span>
  </div>
  <!-- Hours used to read `{bit.hours}h - {bit.description}`: a raw `4h` where the
       rest of the application writes `4.0 h`, joined to the description by a
       hyphen that was left dangling whenever there was no description. -->
  {#if bit.description}
    <p>{bit.description}</p>
  {/if}
  {#if bit.fixedCostMinor}
    <p>Fixed cost <span class="money">{minorToMoney(bit.fixedCostMinor, currency)}</span></p>
  {/if}
  {#if pendingMinor || paidMinor}
    <p class="work-item-history">
      {#if paidMinor}<span>paid {minorToMoney(paidMinor, currency)}/h</span>{/if}
      {#if pendingMinor}<span>pending {minorToMoney(pendingMinor, currency)}/h</span>{/if}
    </p>
  {/if}
  <!-- An unreported item was marked by a hard-coded beige wash that belonged to
       one theme and read as "disabled" on all three. It is not disabled; it is
       withheld, which is a fact and says itself in words. -->
  {#if !bit.reported}
    <p class="work-item-flag">Not reported — payers cannot see or pay for this.</p>
  {/if}
  {#if canManage}
    <div class="work-item-actions">
      <label class="inline-check">
        <input
          checked={bit.reported}
          type="checkbox"
          on:change={(event) => onToggleReported(event.target.checked)}
        />
        Reported
      </label>
      {#if editable}
        <div class="button-row">
          <button type="button" on:click={onEdit}>Edit</button>
          <button class="destructive" type="button" on:click={onRemove}>Remove</button>
        </div>
      {/if}
    </div>
  {/if}
</article>
